// components/cells/CellNumber.tsx
import { Typography } from "@mui/material";
import React from "react";

interface CellNumberProps {
  children?: number | null;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
}

const CellNumber = ({ children, onClick }: CellNumberProps) => {
  const value = typeof children === 'number' ? children : 0;

  return (
    <Typography
      variant="body2"
      color="text.primary"
      onClick={onClick}
      sx={{
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      {value.toLocaleString('en-IN')}
    </Typography>
  );
};

export default CellNumber;
